<div 
  class="splash" 
  [class.visible]="testingSplash ||showSplash && !splashFadeOut"
  [class.fade-out]="splashFadeOut" 
  [class.permanent-background]="testingSplash == false && (hasReachedMinimumTime && !splashFadeOut)"
>
  <div class="splash-content" [class.visible]="showSplash || testingSplash">
    <img 
      [src]="window.innerWidth < smallScreenSize ? splashImageSrcMobile : splashImageSrc" 
      alt="Splash"
      class="absolute-img"
    >

    <div class="splash-bottom">
      <div class="splash-message">Powering up your creativity...</div>
      <div class="loading-spinner" [class.visible]="testingSplash || (showSplash && !splashFadeOut)">
        <div class="spinner"></div>
      </div>
    </div>
  </div>
</div>

<ion-app [class.hide-app]="hideApp">
  <ion-router-outlet [animated]="true" [swipeGesture]="false"></ion-router-outlet>
</ion-app>

<div *ngIf="tutorialService.isTutorialActive" class="tutorial-overlay-root">
  <ng-container *ngIf="tutorialService.activeStepId !== 'lab-members-help'">
    <svg *ngIf="tutorialShadePath" class="tutorial-shade-svg" width="100%" height="100%" [attr.viewBox]="'0 0 ' + window.innerWidth + ' ' + window.innerHeight" preserveAspectRatio="none" aria-hidden="true">
      <path class="tutorial-shade-path" [attr.d]="tutorialShadePath" [attr.fill]="tutorialShadeFill" fill-rule="evenodd"></path>
    </svg>
    <div *ngIf="tutorialHasTarget && !tutorialService.allowActiveTargetInteraction" class="tutorial-spotlight-blocker" [ngStyle]="tutorialSpotlightStyle"></div>
    <div *ngIf="tutorialHasTarget" class="tutorial-spotlight-ring" [ngStyle]="tutorialSpotlightStyle"></div>
  </ng-container>

  <div *ngIf="tutorialService.activeStepId !== 'lab-members-role-help' && tutorialService.activeStepId !== 'gadget-users-role-help'" class="tutorial-sheet-shell" [ngClass]="{'tutorial-sheet-top': tutorialSheetAtTop}">
    <app-tutorial-panel
      (actionClicked)="runTutorialStepAction()"
      (closeClicked)="cancelTutorial()">
    </app-tutorial-panel>
  </div>
</div>

<div *ngIf="tutorialService.shouldShowCompletionCard" class="tutorial-sheet-shell tutorial-sheet-complete">
  <div class="tutorial-sheet-card">
    <span class="tutorial-badge">{{ 'Tutorial Complete' | translate }}</span>
    <p class="tutorial-sheet-title">{{ tutorialService.completionTitle }}</p>
    <p class="tutorial-sheet-text">{{ tutorialService.completionBody }}</p>
    <div class="tutorial-sheet-actions">
      <button *ngIf="tutorialService.justCompletedTutorialId === 'create-lab'" type="button" class="tutorial-complete-button tutorial-continue-button" (click)="continueTutorialCompletion()">{{ 'Continue to Lab Members' | translate }}</button>
      <button *ngIf="tutorialService.justCompletedTutorialId === 'lab-members'" type="button" class="tutorial-complete-button tutorial-continue-button" (click)="continueTutorialCompletion()">{{ 'Continue to Create Gadget' | translate }}</button>
      <button *ngIf="tutorialService.justCompletedTutorialId === 'create-gadget'" type="button" class="tutorial-complete-button tutorial-continue-button" (click)="continueTutorialCompletion()">{{ tutorialService.createGadgetCompletionContinueLabel }}</button>
      <button *ngIf="tutorialService.justCompletedTutorialId === 'gadget-users'" type="button" class="tutorial-complete-button tutorial-continue-button" (click)="continueTutorialCompletion()">{{ 'Continue to Create Component' | translate }}</button>
      <button *ngIf="tutorialService.justCompletedTutorialId === 'create-component'" type="button" class="tutorial-complete-button tutorial-continue-button" (click)="continueTutorialCompletion()">{{ tutorialService.createComponentCompletionContinueLabel }}</button>
      <button *ngIf="tutorialService.justCompletedTutorialId === 'component-guide'" type="button" class="tutorial-complete-button tutorial-continue-button" (click)="continueTutorialCompletion()">{{ 'Continue to Dashboard Tutorial' | translate }}</button>
      <button type="button" class="tutorial-complete-button" (click)="dismissTutorialCompletion()">{{ 'Finished for now' | translate }}</button>
    </div>
  </div>
</div>
